import * as config from './config';
import { token } from '../auth';
import Klickart from './klickart';

const { REQUEST_BODY, MINUTES_TO_UPDATE, PATH } = config.token;
const klickart = new Klickart();

export const get = () => klickart
  .post(REQUEST_BODY, {}, PATH)
  .then(response => {
    token.set(response.data.token);

    return response.data.token;
  });

export const autoUpdate = () => {
  setInterval(() => {
    get();
  }, 1000 * 60 * MINUTES_TO_UPDATE);
};



/** WEBPACK FOOTER **
 ** ./src/helpers/request/token.js
 **/